const getDarkenColor = (color: string) => {
  const percent = 50
  let RGB = []
  RGB.push(parseInt(color.substring(1, 3), 16))
  RGB.push(parseInt(color.substring(3, 5), 16))
  RGB.push(parseInt(color.substring(5, 7), 16))

  RGB = RGB.map(i => {
    i = i * (100 + percent) / 100
    i = (i<255)?i:255
    i = Math.round(i)
    return ((i.toString(16).length==1)?'0'+i.toString(16):i.toString(16))
  })
  return '#' + RGB.join('')
}

export const getColorSetByLength = (length: number) => {
  const colorSet = [
    '#5C87FF',
    '#9C3EFF',
    '#FF74FD',
    '#6CFFB2',
    '#FFB800',
    '#FF5925'
  ]

  const targetLength = length - colorSet.length

  if (targetLength <= 0) {
    return colorSet.slice(0, length)
  }

  for (let i = 0; i < length; i++) {
    colorSet.push(getDarkenColor(colorSet[i]))
  }
  return colorSet
}


export const hexToRGB = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')'
  } else {
    return 'rgb(' + r + ', ' + g + ', ' + b + ')'
  }
}
